import { Api as apiService } from '../api';
export class KeepAliveApi {
    static get() {
        const result = apiService.get(`/api/web/keep_alive`);
        return apiService.responseToJSON(result);
    }
}
